import React from "react";
import PropTypes from "prop-types";
import BreadcrumbItem from "../component/BreadcrumbItem/BreadcrumbItem";
import Page from "../component/Page/Page";
import TransactionView from "./component/TransactionView";

class TransationViewPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Rastreabilidade"/>,
      <BreadcrumbItem key={2} title="Transações" to="/list/transactions"/>,
      <BreadcrumbItem key={3} title="Detalhes da transações" to="#" active={true}/>];
    return (
        <Page title="Detalhes da Transação" breadcrumbs={breadcrumbs}>
          <TransactionView match={match} history={history}/>
        </Page>
    );
  }
}

TransationViewPage.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

export default TransationViewPage;


// WEBPACK FOOTER //
// ./src/transaction/TransationViewPage.js